module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lOuut"))).then(() => parcelRequire('fThBo'));